<template>
  <div class="row">
    <div class="col-md-12 text-center p-l-0 p-r-0">
      <div
        class="progress-circle-indeterminate progress-circle-primary m-t-10"
        style=""
      />
      <br />
      <p :class="'small ' + text_class" v-if="with_text" v-html="text" />
    </div>
  </div>
</template>

<script>
export default {
  name: "loader",
  props: {
    with_text: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    text_class: {
      type: String,
      default: function () {
        return "hint-text";
      },
    },
    text: {
      type: String,
      default: function () {
        return "";
      },
    },
  },
};
</script>